// extracted by mini-css-extract-plugin
export default {"previews":"CampaignSectionPreviews_previews__9Eipw"};